const memberDataLevelEnum = [
  {
    value: "one",
    label: "overview.filterLevel.oneLevel",
    label_tag: "overview.filterLevel.oneLevel",
    is_translation: true,
  },
  {
    value: "two",
    label: "overview.filterLevel.twoLevel",
    label_tag: "overview.filterLevel.twoLevel",
    is_translation: true,
  },
  {
    value: "three",
    label: "overview.filterLevel.threeLevel",
    label_tag: "overview.filterLevel.threeLevel",
    is_translation: true,
  },
  {
    value: "four",
    label: "overview.filterLevel.fourLevel",
    label_tag: "overview.filterLevel.fourLevel",
    is_translation: true,
  },
  {
    value: "all",
    label: "overview.filterLevel.all",
    label_tag: "overview.filterLevel.all",
    is_translation: true,
  },
];

export default memberDataLevelEnum;
